import angular from 'angular';
import template from './TitleBar.template.html';
import { TitleBarController } from './TitleBar.controller';

export const titleBarModule = angular
  .module('bit.components.TitleBar', [])
  .directive('bitTitleBar', () => ({
    scope: {},
    template,
    restrict: 'E',
    controller: TitleBarController,
    controllerAs: 'tbc',
  }));
